import React, { useRef, useEffect, useState } from "react";
import "./Testimonial.css";
// import img from '../../assets/testimonialimg.png'
import img from "../../assets/img1.png";
import img2 from "../../assets/img2.png";
import img3 from "../../assets/img3.png";
import img4 from "../../assets/img4.png";
import b from "../../assets/b.png";
import logo from "../../assets/testimonial_logo.png";
import logo1 from "../../assets/testimonialLogo1.png";
import logo2 from "../../assets/testimonialLogo2.png";
import logo3 from "../../assets/testimonialLogo3.png";
import logo4 from "../../assets/testimonialLogo4.png";
import arrow from "../../assets/arrow-left.png";
import arrow2 from "../../assets/arrow2.png";
// slick import
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    id: 1,
    quote:
      "Switching to NFC cards made networking so much easier for me. One tap and clients have all my details instantly.",
    name: "Rohan Mehta",
    role: "Mumbai, India",
    avatar: img,
    logo: logo1,
  },
  {
    id: 2,
    quote:
      "These cards look so professional and save me from carrying stacks of paper cards. I update my details anytime I want.",
    name: "Akanksha Singh",
    role: "Delhi, India",
    avatar: img4,
    logo: logo2,
  },
  {
    id: 3,
    quote:
      "I love how simple and modern these NFC cards are. Sharing my profile feels effortless and leaves a strong impression.",
    name: "Ahmed Al Mansoori",
    role: "Dubai, UAE",
    avatar: img2,
    logo: logo3,
  },
  {
    id: 4,
    quote:
      "The quality is excellent and it’s eco-friendly too. I’ve been using it at events, and people are always impressed.",
    name: "Fatima Al Zahra",
    role: "Abu Dhabi, UAE",
    avatar: img3,
    logo: logo4,
  },
];

const Testimonial = () => {
  const [slidesToShow, setSlidesToShow] = useState(2);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 769) {
        setSlidesToShow(1);
      } else {
        setSlidesToShow(2);
      }
    };

    handleResize(); // set initially

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const NextArrow = ({ onClick }) => (
    <img src={arrow} alt="Next" className="nextArrow" onClick={onClick} />
  );

  const PrevArrow = ({ onClick }) => (
    <img src={arrow} alt="Previous" className="prevArrow" onClick={onClick} />
  );

  const settings = {
    dots: false,
    arrows: true,
    // autoplay: true,
    infinite: false,
    speed: 900,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    beforeChange: (current, next) => setCurrentSlide(next),
    onPrevClick: () => {
      sliderRef.current.slickPrev();
    },
    onNextClick: () => {
      sliderRef.current.slickNext();
    },
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="containerTestimonial">
        <div className="innerDivTestimonial">
          <div className="resultline">
            <span>
              <img src={b} alt="" />
            </span>
            <h5>Results</h5>
          </div>
          <div className="headingdiv">
            <div className="lefthead">
              <h1 className="secondheading">
                Trusted By <span>Clients</span>{" "}
              </h1>
              {/* <h1 className='secondheading'> <span>performance</span> mindset</h1> */}
              <h1 className="firstheading">Across Industries</h1>
            </div>
            <div className="righthead">
              <p>
                Recommended by entrepreneurs, corporates, and freelancers, our
                NFC cards create lasting impressions. Don’t just take our
                word—see how clients worldwide are transforming the way they
                share details.
              </p>
              <div className="buttondiv">
                {/* <div className='exploreBtn'>Explore our cases <span className='arrowspan'><img src={arrow2} alt="" /></span></div> */}
                <div className="nextPrevButton">
                  <button
                    className="prevArrowBtn"
                    onClick={settings.onPrevClick}
                    style={{
                      backgroundColor:
                        currentSlide === 0 ? "#b9b8b8" : "#212121",
                      cursor: currentSlide === 0 ? "not-allowed" : "pointer",
                    }}
                    disabled={currentSlide === 0}
                  >
                    <PrevArrow />
                  </button>
                  <button
                    className="nextArrowBtn"
                    onClick={settings.onNextClick}
                    style={{
                      backgroundColor:
                        currentSlide >= testimonials.length - slidesToShow
                          ? "#b9b8b8"
                          : "#212121",
                      cursor:
                        currentSlide >= testimonials.length - slidesToShow
                          ? "not-allowed"
                          : "pointer",
                      marginLeft: "8px",
                    }}
                    disabled={
                      currentSlide >= testimonials.length - slidesToShow
                    }
                  >
                    <NextArrow />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Slider {...settings} ref={sliderRef} className="testimonial-slider">
            {testimonials.map((t, index) => (
              <div className="testimonialwrapper" key={t.id}>
                <div
                  key={t.id}
                  className={`testimonial-card ${
                    index === 1 ? "outside-card" : ""
                  }`}
                >
                  <blockquote>“ {t.quote} ”</blockquote>
                  <div className="testimonial-footer">
                    <div className="author">
                      <img src={t.avatar} alt={t.name} />
                      <div>
                        <h4>{t.name}</h4>
                        <p>{t.role}</p>
                      </div>
                    </div>
                    <img src={t.logo} alt="company logo" className="logo" />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default Testimonial;
